import Styles from "./Search.module.scss";
import {LazySearch} from "../../components/Searchbox";

export const Search = () => {
    return <div className={Styles.searchOver}>
        <LazySearch homepage={true} />
    </div>
}